import type { StateCreator } from 'zustand'

import type { AllSlices } from '../types'
import type { CasinoCategory, CasinoSlice } from '../types/casino'

export const createCasinoSlice: StateCreator<
  AllSlices,
  [],
  [],
  CasinoSlice
> = set => ({
  categories: [],
  setCategories: (categories: CasinoCategory[]) =>
    set((state: AllSlices) => ({
      casino: { ...state.casino, categories },
    })),
  categoriesLoading: false,
  setCategoriesLoading: (categoriesLoading: boolean) =>
    set((state: AllSlices) => ({
      casino: { ...state.casino, categoriesLoading },
    })),

  allGames: {},
  setCategoryGames: (categoryKey, categoryGames, fresh) => {
    set(state => {
      return {
        casino: {
          ...state.casino,
          allGames: {
            ...state.casino.allGames,
            [categoryKey]: fresh
              ? categoryGames
              : state.casino.allGames[categoryKey]?.length &&
                Array.isArray(state.casino.allGames[categoryKey])
              ? [...state.casino.allGames[categoryKey], ...categoryGames]
              : categoryGames,
          },
        },
      }
    })
  },
  clearCategoryGames: categoryKey => {
    set(state => ({
      casino: {
        ...state.casino,
        allGames: {
          ...state.casino.allGames,
          [categoryKey]: [],
        },
      },
    }))
  },
  providers: null,
  setProviders: providers => {
    set(state => ({
      casino: { ...state.casino, providers },
    }))
  },
  loadMoreLoading: false,
  setLoadMoreLoading: loadMoreLoading => {
    set(state => ({
      casino: { ...state.casino, loadMoreLoading },
    }))
  },
})
